import React from 'react';
import { Form, Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class WorkersCompCode extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'wcCodeInput';
  mode = 'WC';

  schema = {
    wcCodeInput: {
      errorText: 'Required field',
      label: 'Workers Comp Code',
      required: true,
    },
  };

  state = {
    wcCodeInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedTextInput('wcCodeInput')}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
